import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Main from './main/index';

const App = ({ match }) => (
  <Switch>
    <Route path={`${match.url}`} component={Main} />
  </Switch>
);

export default App;
